const useLookAt = () => {
	const lookAt = (roomObject, click = false) => {
		let toSet = roomObject;
		if (typeof roomObject === 'object') {
			toSet = roomObject?._id?.$oid;
		}
		const lookAtEvent = new CustomEvent('lookAtEvent', {
			detail: { roomObject: toSet, click: click },
		});
		window.dispatchEvent(lookAtEvent);
	};

	return {
		lookAt,
	};
};

export default useLookAt;
